// istanbul ignore file — settings modal embed; mirrors `features/availability/tabs.js` routes without altering it.

import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { HolidaysSection } from 'features/availability/advanced_settings/holidays_section';
import { MeetingLimitsSection } from 'features/availability/advanced_settings/meeting_limits_section';
import { CalendarSettings } from 'features/availability/calendar_settings/calendar_settings';
import { TabPage } from 'features/availability/components/tab_page';
import { SchedulesTab } from 'features/availability/schedules';
import { IcloudConnect, OutlookDesktopRoutes } from 'features/calendar_connections';
const advancedModalBodyCss = "azx2kz2";
const AdvancedModalBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(advancedModalBodyCss, props.className)} />;
});
const SettingsModalCalendarSettingsPane = () => <TabPage omitHeader withinModal omitOuterBorder pageTitle={I18n.t('publisher.availability_settings.section.calendar_settings.title')}>
    <CalendarSettings />
  </TabPage>;
const SettingsModalAdvancedAvailabilityPane = () => <TabPage omitHeader withinModal omitOuterBorder pageTitle={I18n.t('publisher.personal_settings.calendar_section.tabs.advanced')}>
    <AdvancedModalBody>
      <MeetingLimitsSection />
      <HolidaysSection />
    </AdvancedModalBody>
  </TabPage>;

/**
 * Memory-routed availability area for the settings modal (`?settings=calendar` + optional `settings_tab`).
 * Reuses the same route table as {@link features/availability/tabs.js} without modifying that module.
 */
export const SettingsModalCalendarMemoryPage = ({
  match
}) => {
  const {
    search
  } = useLocation();
  return <Switch>
      <Redirect from={`${match.url}/default_schedule`} to={`${match.url}/schedules`} />
      <Route path={`${match.url}/schedules/:id?`} exact render={routeProps => <SchedulesTab {...routeProps} withinModal omitOuterBorder />} />
      <Route path={`${match.url}/calendar_settings`} component={SettingsModalCalendarSettingsPane} />
      <Route path={`${match.url}/connected_calendars/outlook_desktop`} component={OutlookDesktopRoutes} />
      <Route path={`${match.url}/connected_calendars/icloud/new`} component={IcloudConnect} />
      <Route path={`${match.url}/advanced_settings`} component={SettingsModalAdvancedAvailabilityPane} />
      <Redirect from={`${match.url}/connected_calendars`} to={{
      pathname: `${match.url}/calendar_settings`,
      search
    }} exact />
      <Redirect from={`${match.url}/holidays`} to={{
      pathname: `${match.url}/advanced_settings`,
      search
    }} />
      <Redirect from={`${match.url}/holidays_and_out_dates`} to={{
      pathname: `${match.url}/advanced_settings`,
      search
    }} />
      <Redirect from={`${match.url}`} to={{
      pathname: `${match.url}/schedules`,
      search
    }} />
    </Switch>;
};

require("./settings_modal_calendar_memory_page.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./settings_modal_calendar_memory_page.js");